module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Dropdown-Dropdown 1_right_Gray.d7a3c355.svg";